export default "__VITE_ASSET__nDb97Lrk__ 1600w, __VITE_ASSET__mtjt7fK9__ 800w";